const state = () => ({
  settings: {
    showBoxInContent: false,
    boxTitleNL: "",
    boxContentNL: "",
    releaseNotesButtonLabelNL: "",
    platformUpdatesButtonLabelNL: "",
    scheduledMaintenanceButtonLabelNL: "",
    releaseNotesButtonLinkNL: "",
    platformUpdatesButtonLinkNL: "",
    scheduledMaintenanceButtonLinkNL: "",
    boxTitleDE: "",
    boxContentDE: "",
    releaseNotesButtonLabelDE: "",
    platformUpdatesButtonLabelDE: "",
    scheduledMaintenanceButtonLabelDE: "",
    releaseNotesButtonLinkDE: "",
    platformUpdatesButtonLinkDE: "",
    scheduledMaintenanceButtonLinkDE: ""
  },
  hasModalError: false,
  modalErrorMessage: ""
});

const getters = {};

const actions = {};

const mutations = {
  updateShowBox(state, val) {
    state.settings.showBoxInContent = val;
  },
  setSettings(state, val) {
    state.settings = { ...state.settings, ...val };
  },
  updateSetting(state, { key, value }) {
    state.settings[key] = value;
  },
  enableModalError(state) {
    state.hasModalError = true;
  },
  disableModalError(state) {
    state.hasModalError = false;
    state.modalErrorMessage = "";
  },
  updateModalError(state, message) {
    state.modalErrorMessage = message;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
